import Header from '../components/Header'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import GlobalState, { watchVideo, setLang } from '../stores/GlobalState'
import { observer } from 'mobx-react'
import ContentState, {
  getContantContent,
  getCoopContent,
  getFooter,
  getHomeContent,
  getMenu,
  getProductsPage,
  getSubMenu,
} from '../stores/ContentState'
import Menu from '../components/Menu'
import LocaleMenu from '../components/LocaleMenu'
import { ReactComponent as Chat } from '../assets/message-square.svg'
import { ReactComponent as Arrow } from '../assets/arrow-left.svg'

import Footer from '../components/Footer'
import ProductsContent from '../components/pages/products/ProductsContent'
import Coop from '../components/common/CoopPop'
import VideoBox from '../components/VideoBox'
import Cookie from '../components/common/Cookie'
import Preloader from '../components/Preloader'
import { useLocation } from 'react-router'
import changeLocaleByPath from '../mocks/changeLocale'

const ProductsPage = observer(() => {
  const [loading, setLoading] = useState(true)

  const { pathname } = useLocation()
  useEffect(() => {
    changeLocaleByPath(pathname)

    setLang()
    getMenu()
    getSubMenu()
    getFooter()
    getCoopContent()
    getHomeContent().then(() => {})
    getProductsPage().then(() => {
      // document.title = `Нова Пошта | ${(ContentState.products as any)?.title}`
      ContentState.menu &&
        setTimeout(() => {
          setLoading(false)
        }, 200)
    })

    return () => {
      setLoading(true)
    }
  }, [])

  useEffect(() => {
    if (loading) return
    document.querySelector('html')?.classList.add('auto')
    document.querySelector('body')?.classList.add('auto')
    document.querySelector('.header')?.classList.remove('light')
    ;(document.querySelector('.button.chat') as HTMLElement)?.classList.add(
      'contact',
    )
    document.querySelector('.navigation')?.classList.remove('light')

    if (width <= 900) {
      setTimeout(() => {
        document.querySelector('.header')?.classList.add('light')
        document.querySelector('.navigation')?.classList.add('light')
      }, 0)
    } else {
    }
    //  document.querySelector('.grecaptcha-badge')?.classList.add('no-display')
    document.querySelector('#root')?.classList.add('visible')
    document.querySelector('#root')?.classList.add('auto')
    document.querySelector('#root')?.classList.add('products')
    return () => {
      document.querySelector('#root')?.classList.remove('visible')
    }
  }, [loading])

  useEffect(() => {
    window.addEventListener('keydown', function (event: any) {
      if (
        event.ctrlKey == true &&
        (event.which == '61' ||
          event.which == '107' ||
          event.which == '173' ||
          event.which == '109' ||
          event.which == '187' ||
          event.which == '189')
      ) {
        event.preventDefault()
      }
      if (
        event.which != '86' &&
        event.which != '67' &&
        event.metaKey &&
        event.which != 65
      ) {
        event.preventDefault()
      }
    })

    window.addEventListener('mousewheel DOMMouseScroll', function (event: any) {
      if (event.ctrlKey == true) {
        event.preventDefault()
      }
    })
  }, [])

  useEffect(() => {
    if (GlobalState.isCoopShow) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isCoopShow])
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', (e) => {
      const header = document.querySelector('.header')

      if (!header) return
      if (window.scrollY > header?.getBoundingClientRect().height / 4) {
        header.classList.add('header-hidden')
      } else {
        header.classList.remove('header-hidden')
      }
    })
  }, [])

  if (!ContentState.products) return <></>
  return (
    <>
      <Header /> <Cookie />
      {/* <div className="button chat" id="chat">
        <Chat />
      </div> */}
      {/* <Preloader loading={loading} /> */}
      {!loading && (
        <div
          className={classNames(
            'container smooth-scroll',
            loading && 'hidden',
            !loading && 'visible',
            GlobalState.isLocaleOpen && 'overflow',
            GlobalState.isMenuOpen && 'overflow',
          )}
        >
          <ProductsContent />
          <Footer />
        </div>
      )}
      <VideoBox
        src={GlobalState.video.src}
        poster={GlobalState.video.poster}
        setShow={() =>
          watchVideo(GlobalState.video.src, GlobalState.video.poster)
        }
      />
      <Menu />
      <LocaleMenu />
      {GlobalState.isCoopShow && <Coop />}{' '}
      {width > 480 && !loading && (
        <div
          className="team__bottom-arrow"
          onClick={() => {
            window.scrollTo(0, 0)
          }}
        >
          <Arrow />
        </div>
      )}
      <div
        className={classNames('menu__bg', GlobalState.isMenuOpen && 'show')}
      ></div>
      <div
        className={classNames('menu__bg', GlobalState.isLocaleOpen && 'show')}
      ></div>
    </>
  )
})

export default ProductsPage
